<template>
  <v-container fluid fill-height>
    <v-layout wrap fill-height justify-center align-center>
      <v-flex xs12 md4>
        <v-card>
          <v-btn icon @click="$router.push({ name: 'login' })">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-card-title class="d-block text-center">
            <span class="font-weight-medium">Hesap Doğrulama</span>
          </v-card-title>
          <div class="d-block text-center">
            <span class=" heading font-weight-thin">
              Oturum açmak için lütfen SMS doğrulamasını tamamlayınız.
            </span>
          </div>
          <v-card-text>
            <span
                v-if="resendResponse !== ''"
                class="subtitle-1 mt-2 primary--text">
              {{ resendResponse }}
            </span>
            <v-text-field
                v-model="key"
                maxlength="6"
                type="numeric"
                label="Telefonunuza gelen 6 haneli kodu giriniz">
            </v-text-field>
          </v-card-text>
          <v-card-actions class="d-block text-right">
            <v-btn color="primary" @click="authorize" :disabled="loadingAuthorize || loadingResend" :loading="loadingAuthorize">Doğrula</v-btn>
            <v-btn class="mr-2" @click="reAuthorize" :disabled="loadingResend || loadingAuthorize" :loading="loadingResend">Tekrar Gönder</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'TwoFA',
  data: () => ({
    key: '',
    resendResponse: '',
    loadingAuthorize: false,
    loadingResend: false,
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    authorize() {
      this.loadingAuthorize = true;
      this.$store.dispatch('login', {
        key: this.key,
        hash: this.$store.state.twoFA.hash,
        selected_auth_number: this.$store.state.twoFA.selected_auth_number,
      })
          .then(() => {
            this.$router.push({ name: 'dashboard' });
          })
          .finally(() => {
            this.loadingAuthorize = false;
          });
    },
    reAuthorize() {
      this.loadingResend = true;
      this.send({
        route: 'two/step/login/resend',
        data: { resend_key: this.$store.state.twoFA.resend },
      })
          .then((res) => {
            this.resendResponse = res.data.description;
          })
          .finally(() => {
            this.loadingResend = false;
          });
    },
  },
  // async created() {
  //   await this.reAuthorize();
  // },
};
</script>
